<template>
    <div class="retail-size">
        <size />
    </div>
</template>

<style scoped>
.retail-size ::v-deep .size > .button.button-color {
    background-color: #ffffff;
    border: 2px solid #000000;
    border-radius: 12px 12px 12px 12px;
    color: #000000;
    float: left;
    font-size: 20px;
    font-weight: 500;
    height: 48px;
    line-height: 48px;
    text-transform: uppercase;
    transition: background-color 0.25s ease-in-out, color 0.25s ease-in-out;
    width: 176px;
}

.retail-size ::v-deep .size > .button.button-color:active {
    background-color: #000000;
    color: #ffffff;
}

@media screen and (max-height: 1340px) {

    .retail-size ::v-deep .size > .button.button-size {
        font-size: 12px;
        height: 38px;
        line-height: 40px;
    }
}

@media screen and (max-width: 1024px) {

    .retail-size ::v-deep .size > .button.button-size {
        width: 22vw;
    }
}
</style>

<script>
export const RetailSize = {
    name: "retail-size"
};

export default RetailSize;
</script>
